<template>
  <div id="product">
    <follow-up-contact />
    <div class="gallery-wrapper">
      <product-top-bar />
      <slide-gallery />
    </div>
    <div id="product-info">
        <product-info />
        <div class="animation">
        </div>
        <product-features />
    </div>
    <info-banner />
    <product-footer />
  </div>
</template>
<script>
import ProductTopBar from '@/components/product/ProductTopBar'
import ProductInfo from '@/components/product/ProductInfo.vue'
import SlideGallery from '../components/product/SlideGallery'
import InfoBanner from '../components/product/ProductInfoBanner'
import ProductFeatures from '../components/product/ProductFeatures.vue'
import ProductFooter from '@/components/product/ProductFooter'
import FollowUpContact from '../components/product/FollowUpContact'
export default {
  name: 'product',
  components: { ProductTopBar, ProductInfo, SlideGallery, ProductFeatures, InfoBanner, ProductFooter, FollowUpContact },
  data () {
    return {
    }
  }
}
</script>
<style lang="scss">
@import '../assets/scss/variables.scss';
#product {
  background: #EEE;
  color: #333;
  font-family: MuseoSans-300;
  p {
    font-size: 1.2em;
    line-height: 1.1em;
  }
  #product-info {
    width: 85em;
    padding: 1em;
    max-width: 100%;
    margin: auto;
    background: white;
    box-shadow: 0 1em 1em rgba(#333, .1);
  }
}
h2{
  color: $turq;
  font-size: 2.1em;
  font-family: MuseoSans-900;
  font-weight: 900;
  text-transform: uppercase;
}
h3{
  font-size: 2em;
  color: $lime-text;
  font-family: MuseoSans-900;
  font-weight: 900;
  text-transform: uppercase;
}

</style>


// WEBPACK FOOTER //
// src/pages/PageProduct.vue